import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0af5172d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af5172d')) {
      api.createRecord('0af5172d', component.options)
    } else {
      api.reload('0af5172d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0af5172d", function () {
      api.rerender('0af5172d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/notify/index.vue"
export default component.exports